import { useMemo } from 'react';
import useGetAllRelationships from './useGetAllRelationships';
import useRelevantRelationships from './useRelevantRelationships';
import useGetLinkedEntities from './useGetLinkedEntities';
import usePlugins from './usePlugins';

export default (sourceEntityType, sourceEntityId, plugins, pageLimit) => {
  const { typeToPlugin, entityTypes } = usePlugins(plugins);
  const sourceEntityIdArr = useMemo(() => [sourceEntityId], [sourceEntityId]);

  const {
    relationships: allRelationships,
    isLoading: isLoadingRelationships,
    error: errorLoadingRelationships,
    retry: reloadRelationships
  } = useGetAllRelationships(sourceEntityType, sourceEntityIdArr);
  const relationships = useRelevantRelationships(
    sourceEntityType,
    entityTypes,
    allRelationships,
    isLoadingRelationships
  );
  const {
    isLoading: isLoadingEntities,
    error: errorLoadingEntities,
    retry: retryLoadingEntities,
    ...rest
  } = useGetLinkedEntities({
    sourceEntityType,
    sourceEntityId,
    entityTypes,
    typeToPlugin,
    relationships,
    pageLimit
  });

  const isLoading = isLoadingRelationships || isLoadingEntities;
  const error = errorLoadingRelationships || errorLoadingEntities;
  const retry = error
    ? () => {
      errorLoadingRelationships && reloadRelationships();
      errorLoadingEntities && retryLoadingEntities();
    }
    : undefined;
  return { ...rest, isLoading, error, retry };
};
